import {MessageDisplayStrategy} from "@app/core/user-marketing-rules/application/message-display-strategy";
import {Platform} from "@angular/cdk/platform";
import {Injectable} from "@angular/core";

/**
 * Provides a browser-specific strategy for determining whether certain messages (e.g. "Download App") can be displayed.
 */
@Injectable()
export class BrowserMessageDisplayStrategy implements MessageDisplayStrategy {

    constructor(
        private platform: Platform
    ) {}

    canDisplayDownloadAppMessage(): boolean {
        return this.platform.ANDROID || this.platform.IOS;
    }
}